import { Button, Col, FormCheck, Modal, Row } from "react-bootstrap";
// import { timeMinuteDefaults } from "../../util/timeMinuteDefaults.jsx";
import { useState, Fragment, useEffect } from "react";
import { saveAs } from "file-saver";
import {
  useGetAllBreaksQuery,
  useGetAllSchedulesQuery,
} from "../../slices/damApiSlice";
import {
  useGetDaysPlaylistQuery,
  usePopulateProgramsMutation,
  useRePopulateProgramsMutation,
  useSaveSongAddPromoPlaysMutation,
  useLockDateMutation,
} from "../../slices/playlistsApiSlice";
import { toast } from "react-toastify";

const ModalPlaylist = ({
  daysPrograms,
  setShowModalPlaylist,
  graphics,
  isLocked,
}) => {
  const [allPrograms, setAllPrograms] = useState(daysPrograms);
  const [songsPlayCounter, setSongsPlayCounter] = useState(null);
  const [isPopulated, setIsPopulated] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [addsForSectionBase, setAddsForSectionBase] = useState(null);
  const [promosForSectionBase, setPromosForSectionBase] = useState(null);
  const [notifyChecked, setNotifyChecked] = useState(true);

  // var { hours, minutes } = timeMinuteDefaults();
  const { data: breaks } = useGetAllBreaksQuery();
  const { data: schedules } = useGetAllSchedulesQuery();

  const [txDate] = useState(allPrograms[0].txDate);

  // Get Next Day Date
  const txDateObj = new Date(txDate);
  const txDateNextDay = new Date(txDateObj.setDate(txDateObj.getDate() + 1));
  const txDateNextDayISO = new Date(txDateNextDay.toISOString());

  const { data: nextDayPrograms } = useGetDaysPlaylistQuery(
    txDateNextDayISO.getTime()
  );

  function formatDate(txDate) {
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    const date = new Date(txDate);
    return date.toLocaleDateString("en-GB", options);
  }

  const formattedDate = formatDate(txDate);

  const [populatePrograms] = usePopulateProgramsMutation();
  const [rePopulatePrograms] = useRePopulateProgramsMutation();
  const [saveSongAddPromoPlays] = useSaveSongAddPromoPlaysMutation();
  const [lockDateUpdate] = useLockDateMutation();

  useEffect(() => { 
    console.log("allPrograms", allPrograms);
  }, [allPrograms]);

  useEffect(() => {
    const fetchData = async () => {
      let response = null;
      if (allPrograms[0].isPopulated) {
        response = await rePopulatePrograms(allPrograms);
        setIsSaved(true);
      } else {
        response = await populatePrograms(allPrograms);
        setIsSaved(false);
      }
      console.log("response", response);

      const populatedPrograms = response.data.programs;
      const songPlayCounter = response.data.songs;
      const addsPlayCounter = response.data.addsForSection;
      const promosPlayCounter = response.data.promosForSection;

      setPromosForSectionBase(promosPlayCounter);
      setAddsForSectionBase(addsPlayCounter);
      setSongsPlayCounter(songPlayCounter);
      setAllPrograms(populatedPrograms);
      setIsPopulated(true);
    };

    fetchData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (songsPlayCounter) {
      setSongsPlayCounter((prevState) => {
        return prevState.map((song) => {
          return { ...song, isNotify: notifyChecked };
        });
      });
    }
    // eslint-disable-next-line
  }, [notifyChecked]);

  const handlePlaylist = async (e) => {
    e.preventDefault();

    if (!allPrograms || allPrograms.length === 0) {
      setShowModalPlaylist(false);
      const toastMsg = "No days programs available.";
      toast.error(toastMsg, {
        position: "top-center",
        autoClose: 20000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    let completeDay = true;
    let startTime = allPrograms[0].programs.sections[0].startTime;
    allPrograms.forEach((program, programIndex) => { 
      program.programs.sections.forEach((section, index) => {
        if (section.startTime !== startTime) {
          completeDay = false;
        }
        startTime = section.startTime + (section.sectionRuntime / 60);
       })
    })
    if (!completeDay) {
      setShowModalPlaylist(false);
      const toastMsg =
        "There is an error in the playlist.   Please correct and try again.   PLAYLIST FILE HAS NOT BEEN CREATED";
      toast.error(toastMsg, {
        position: "top-center",
        autoClose: 20000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    

    const getTimeString = (seconds) => {
      return new Date(seconds * 1000).toISOString().substring(11, 19);
    };

    const getRandomItem = (array) => {
      if (array.length > 0) {
        return array[Math.floor(Math.random() * array.length)];
      }
    };

    const processLiveGraphics = (programGraphics, titleSection) => {
      return graphics
        ?.filter((liveGraphic) => {
          if (!programGraphics) return false;

          const liveGraphicsObject = programGraphics.find(
            (item) => item.value === liveGraphic.value
          );
          return liveGraphicsObject && liveGraphic.titleSection === titleSection
            ? liveGraphic
            : null;
        })
        ?.map((liveGraphic) => liveGraphic.code)
        .join(" ");
    };

    let fileText = "";

    const getPreRoll = (program) =>
      program.isLive?.isLive ? program.preRoll.live : program.preRoll.file;

    const getFixedTime = (section, preRoll, program) => {
      return (
        section.startTime * 60 -
        preRoll.ident.details[0].seconds -
        (program.isLive?.isLive ? preRoll.introIdent.details[0].seconds : 0) -
        (program.isLive?.isLive ? 2 : 0)
      );
    };

    const getIdentStartTime = (fixedTime) => getTimeString(fixedTime);

    const getWaitTime = (fixedTime, preRoll) =>
      fixedTime + preRoll.introIdent.details[0].seconds + 2;

    let TapeId = "";
    let StarPerformer = "";
    let Category = "";

    const getGraphicsDetails = (preRoll, fileText) => {
      TapeId = processLiveGraphics(preRoll?.graphics?.graphics, 1);
      StarPerformer = processLiveGraphics(preRoll?.graphics?.graphics, 2);
      Category = processLiveGraphics(preRoll?.graphics?.graphics, 3);

      if (TapeId) fileText += `#TAPEID ${TapeId}\n`;
      if (StarPerformer) fileText += `#PERFORMER ${StarPerformer}\n`;
      if (Category) fileText += `#CATEGORY ${Category}\n`;

      return fileText;
    };

    const getLiveDetails = (preRoll, section, program, fileText) => {
      TapeId = processLiveGraphics(preRoll?.media?.media, 1);
      StarPerformer = processLiveGraphics(preRoll?.media?.media, 2);
      Category = processLiveGraphics(preRoll?.media?.media, 3);

      if (TapeId) fileText += `#TAPEID ${TapeId}\n`;
      if (StarPerformer) fileText += `#PERFORMER ${StarPerformer}\n`;
      if (Category) fileText += `#CATEGORY ${Category}\n`;

      fileText += `"LIVE://Live1"; 0.00000; ${section.mediaRuntime}.00000; ; ${program.name.name} - Live Program\n`;

      return fileText;
    };

    const getBreakCode = (breaks) => getRandomItem(breaks);

    const getScheduleCode = (schedules) => getRandomItem(schedules);
    let playlistStartTime = 0;

    allPrograms.forEach((program, programIndex) => {
      if (programIndex === 0) {
        playlistStartTime = program.programs.startTime.startTime;
      }
      program.programs.sections.forEach((section, index) => {
        const preRoll = getPreRoll(program.programs);
        let fixedTime = getFixedTime(section, preRoll, program.programs);
        if (programIndex === 0) {
          fixedTime = fixedTime + 20;
        }
        const identStartTime = getIdentStartTime(fixedTime);

        fileText += `#STARTTIME 1;${
          section.startTime === 0 ? "00:00:10" : identStartTime
        };-1;-1;0;PM;0\n`;

        if (program.programs.isLive?.isLive) {
          fileText += `${preRoll.introIdent.details[0].code}\n`;
          const waitTime = getWaitTime(fixedTime, preRoll);
          fileText += `#EVENT WAITTO ${waitTime}.00000\n`;
        }

        fileText = getGraphicsDetails(preRoll, fileText);

        fileText += `${preRoll.ident.details[0].code}\n`;

        if (index === 0) {
          fileText += `#EVENT NOTE TimeCode\n#CATEGORY Program\n`;
        } else {
          fileText += `#EVENT NOTE TimeCode\n`;
        }

        fileText += `#MISSING\n""; 0.00000; 0.00000; ; ${program.programs.name.name}\n`;

        if (program.programs.isLive?.isLive) {
          fileText = getLiveDetails(
            preRoll,
            section,
            program.programs,
            fileText
          );
        }

        const breakCode = getBreakCode(breaks);

        // insert inProgramBreaks
        if (program.programs.inProgramBreaks?.inProgramBreaks > 0) {
          for (
            let i = 0;
            i < program.programs.inProgramBreaks.inProgramBreaks;
            i++
          ) {
            if (Category) fileText += `#CATEGORY ${Category}\n`;
            fileText += `${breakCode.code}\n`;
            fileText += `${preRoll.ident.details[0].code}\n`;
          }
        }

        // Insert Songs
        if (section.songs && section.songs.length > 0) {
          section.songs.forEach((song) => {
            fileText += `#CATEGORY LogoSong\n`;
            const songsText = song.code.replace(
              /[^;]*$/,
              " PS - " + song.artist + " - " + song.title
            );
            fileText += `${songsText}\n`;
          });
        }

        fileText += `#PERFORMER StopAll\n${breakCode.code}\n`;

        if (index === program.programs.sections.length - 1) {
          const scheduleCode = getScheduleCode(schedules);
          fileText += `${scheduleCode.code}\n`;
        }

        if (section.song && section.song.length > 0) {
          section.song.forEach((songPlay) => {
            fileText += `#CATEGORY LogoSong\n`;
            const songText = songPlay.code.replace(
              /[^;]*$/,
              " PSB - " + songPlay.artist + " - " + songPlay.title
            );
            fileText += `${songText}\n`;
            fileText += `${breakCode.code}\n`;
          });
        }

        if (section.adds) {
          section.adds.forEach((add) => {
            const addsText = add.code.replace(
              /[^;]*$/,
              " A - " + add.organisation + " - " + add.title
            );
            fileText += `${addsText}\n`;
          });
        }
        if (section.promos) {
          section.promos.forEach((promoPlay) => {
            const promosText = promoPlay.code.replace(
              /[^;]*$/,
              " P - " + promoPlay.organisation + " - " + promoPlay.title
            );
            fileText += `${promosText}\n`;
          });
        }
      });
    });

    const titleSectionMap = {
      1: "#TAPEID",
      2: "#PERFORMER",
      3: "#CATEGORY",
    };

    fileText += `#EVENT FILL 10800;PM\n`;

    // insert next day programs
    nextDayPrograms.slice(0, 7).forEach((nextDayProgram, index) => {
      const hours = Math.floor(
        nextDayProgram.programs.startTime.startTime / 60
      );
      const remainingMinutes = nextDayProgram.programs.startTime.startTime % 60;
      const timeString = `${hours
        .toString()
        .padStart(2, "0")}:${remainingMinutes.toString().padStart(2, "0")}:49`;
      fileText += `#STARTTIME 1;${timeString};-1;-1;0;;1\n`;
      fileText += `#CATEGORY Program\n#MISSING\n""; 0.00000; 0.00000; ; ${nextDayProgram.programs.name.name}\n`;
    });

    graphics.forEach((graphicsObject) => {
      const title = titleSectionMap[graphicsObject.titleSection];
      if (title) {
        fileText += `${title} ${graphicsObject.code}\n"D:\\Gap\\Breaks\\Break Clip 1.mpg"; 0.00000; 1.76000; ; Blink\n`;
      }
    });

    if (playlistStartTime < 10) {
      playlistStartTime = `00_0${playlistStartTime}_00`;
    } else {
      playlistStartTime = `00_${playlistStartTime}_00`;
    }

    const playlistDate = new Date(txDate);
    const ymd = playlistDate.toISOString().split("T")[0].split("-");
    let fileName;
    if (process.env.REACT_APP_ENV === "development") {
      fileName = `dev-${ymd[0]}_${ymd[1]}_${ymd[2]}_${playlistStartTime}.ply`;
    } else if (process.env.REACT_APP_ENV === "staging") {
      fileName = `stage-${ymd[0]}_${ymd[1]}_${ymd[2]}_${playlistStartTime}.ply`;
    } else {
      fileName = `${ymd[0]}_${ymd[1]}_${ymd[2]}_${playlistStartTime}.ply`;
    }
    const file = new Blob([fileText], {
      type: "text/plain;charset=utf-8",
    });

    saveAs(file, fileName);

    await new Promise((resolve) => setTimeout(resolve, 2000)); // 1000 milliseconds delay

    async function handleLockDate(isLocked) {
      const confirmationMessage = isLocked
        ? "Do you want to send notifications"
        : "Do you want to lock and send notifications";
      const shouldProceed = window.confirm(confirmationMessage);

      if (shouldProceed) {
        const lockDate = {
          txDateId: allPrograms[0].programs.txDateId,
          songs: songsPlayCounter,
        };
        try {
          await lockDateUpdate(lockDate);
        } catch (error) {
          console.error("Failed to update lock date:", error);
        }
      }
    }
    handleLockDate(isLocked);
    setShowModalPlaylist(false);
  };

  const handleSaveClick = async (e) => {
    e.preventDefault();
    setIsSaved(true);
    setIsPopulated(true);
    await saveSongAddPromoPlays(allPrograms);
  };

  const handlePopulate = async (e) => {
    e.preventDefault();

    const response = await populatePrograms(allPrograms);
    const populatedPrograms = response.data.programs;
    const songPlayCounter = response.data.songs;
    const addsPlayCounter = response.data.addsForSection;
    const promosPlayCounter = response.data.promosForSection;

    setSongsPlayCounter(songPlayCounter);
    setAddsForSectionBase(addsPlayCounter);
    setPromosForSectionBase(promosPlayCounter);
    setAllPrograms(populatedPrograms);
  };

  const handleNotifyChange = async (e) => {
    const { value } = e.target;
    const intValue = parseInt(value);

    setSongsPlayCounter((prevState) => {
      return prevState.map((song, index) => {
        if (index === intValue) {
          return { ...song, isNotify: !song.isNotify };
        }
        return song;
      });
    });
  };

  const handleNotifyClick = async () => {
    const filteredSongsPlayCounter = songsPlayCounter.filter(
      (item) => item.isNotify
    );
    const lockDate = {
      txDateId: allPrograms[0].programs.txDateId,
      songs: filteredSongsPlayCounter,
    };
    try {
      await lockDateUpdate(lockDate);
    } catch (error) {
      console.error("Failed to update lock date:", error);
    }
  };

  function formatDateDDMMYY(time) {
    const songTime = new Date(time);
    const day = songTime.getDate().toString().padStart(2, "0");
    const month = (songTime.getMonth() + 1).toString().padStart(2, "0"); // getMonth() is zero-based
    const year = songTime.getFullYear().toString().slice(-2);

    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  }

  function minutesToHm(time) {
    let minutes = time;
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;

    let timeString = `${hours.toString().padStart(2, "0")}:${remainingMinutes
      .toString()
      .padStart(2, "0")}`;

    return timeString;
  }

  function secondsToHms(startOfSong) {
    let hours = Math.floor(startOfSong / 3600);
    let minutes = Math.floor((startOfSong % 3600) / 60);
    let seconds = startOfSong % 60;

    return [hours, minutes, seconds]
      .map((v) => (v < 10 ? "0" + v : v))
      .join(":");
  }

  function secondsToHm(startOfSong) {
    let hours = Math.floor(startOfSong / 3600);
    let minutes = Math.floor((startOfSong % 3600) / 60);

    return [hours, minutes].map((v) => (v < 10 ? "0" + v : v)).join(":");
  }

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Playlist Details for {formattedDate}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {allPrograms &&
          allPrograms.map((program, i) => (
            <Fragment key={i}>
              <small>
                <Row className="pt-2">
                  <Col xs={1}>
                    {minutesToHm(program.programs.startTime.startTime)}
                  </Col>
                  <Col
                    xs={2}
                    className="text-truncate"
                  >
                    {program.programs.name.name}
                  </Col>
                  <Col>
                    {program.programs.sections.map((section, j) => (
                      <Fragment key={j}>
                        <Row className="pb-1 ">
                          <Col xs={3}>
                            Part {section.section} - Start{" "}
                            {minutesToHm(section.startTime)}
                          </Col>
                          <Col>
                            {section.songs &&
                              section.songs.map((song, k) => (
                                <Row
                                  className="text-danger "
                                  key={k}
                                >
                                  <Col xs={2}>
                                    {secondsToHms(song.startTime)}
                                  </Col>
                                  <Col className="text-truncate">
                                    PS - {song.artist} - {song.title}
                                  </Col>
                                  <Col xs={2}>
                                    e:{" "}
                                    {secondsToHms(
                                      song.startTime + song.duration
                                    )}
                                  </Col>
                                </Row>
                              ))}
                            {section.song &&
                              section.song.map((song, k) => (
                                <Row
                                  className="text-danger "
                                  key={k}
                                >
                                  <Col xs={2}>
                                    {secondsToHms(song.startTime)}
                                  </Col>
                                  <Col className="text-truncate">
                                    PSB - {song.artist} - {song.title}
                                  </Col>
                                  <Col xs={2}>
                                    e:{" "}
                                    {secondsToHms(
                                      song.startTime + song.duration
                                    )}
                                  </Col>
                                </Row>
                              ))}
                            {section.adds &&
                              section.adds.map((add, i) => (
                                <Row
                                  key={i}
                                  className="text-success "
                                >
                                  <Col xs={2}>
                                    {secondsToHms(add.startTime)}
                                  </Col>
                                  <Col>
                                    A - {add.organisation} - {add.title}
                                  </Col>
                                  <Col xs={2}>
                                    e:{" "}
                                    {secondsToHms(add.startTime + add.duration)}
                                  </Col>
                                </Row>
                              ))}
                            {section.promos &&
                              section.promos.map((promo, i) => (
                                <Row
                                  key={i}
                                  className="text-primary "
                                >
                                  <Col xs={2}>
                                    {/* {add.startTime} */}
                                    {secondsToHms(promo.startTime)}
                                  </Col>
                                  <Col>
                                    P - {promo.organisation} - {promo.title}
                                  </Col>
                                  <Col xs={2}>
                                    e:{" "}
                                    {secondsToHms(
                                      promo.startTime + promo.duration
                                    )}
                                  </Col>
                                </Row>
                              ))}
                          </Col>
                        </Row>
                      </Fragment>
                    ))}
                  </Col>
                </Row>
              </small>
            </Fragment>
          ))}
        <Row className="mt-2 pt-1 border-top">
          <Col
            xs={12}
            className="fs-5"
          >
            Songs
          </Col>
        </Row>

        <small className="m-4">
          <Row className="pb-2">
            <Col xs={9}></Col>
            <Col
              xs={2}
              className="text-end"
            >
              {notifyChecked ? "Deselect All" : "Select All"}
            </Col>
            <Col
              xs={1}
              className="text-danger"
            >
              <FormCheck
                type="checkbox"
                checked={notifyChecked}
                onChange={() => setNotifyChecked(!notifyChecked)}
                isValid
              />
            </Col>
          </Row>
          <Row>
            {isPopulated &&
              songsPlayCounter &&
              songsPlayCounter.map((song, i) => (
                <Fragment key={i}>
                  {/* <Col xs={1}>{formatDateDDMMYY(txDate)}</Col> */}
                  <Col
                    xs={2}
                    className="text-truncate"
                  >
                    {song.artist}
                  </Col>
                  <Col
                    xs={2}
                    className="text-truncate"
                  >
                    {song.title}
                  </Col>
                  <Col xs={1}>{song.numberOfTimesSongPlayed} - Plays</Col>
                  <Col xs={2}>
                    {song.playTimes.map(
                      (playTime) => secondsToHm(playTime) + ",  "
                    )}
                  </Col>
                  <Col xs={2}>Start: {formatDateDDMMYY(song.start)}</Col>
                  <Col xs={2}>End: {formatDateDDMMYY(song.end)}</Col>
                  <Col
                    xs={1}
                    className="text-center"
                  >
                    <FormCheck
                      type="checkbox"
                      checked={song.isNotify ? true : false}
                      onChange={(i) => handleNotifyChange(i)}
                      value={i}
                      isValid
                    />
                  </Col>
                </Fragment>
              ))}
          </Row>
          <Row className="pe-5 pt-4">
            <Col xs={11} />
            <Col
              className="text-center"
              xs={1}
            >
              <Button
                variant="success"
                size="sm"
                onClick={() => {
                  handleNotifyClick();
                }}
              >
                Notify
              </Button>
            </Col>
          </Row>
        </small>
        <Row className="mt-2 pt-1 border-top">
          <Col
            xs={12}
            className="fs-5"
          >
            Adds
          </Col>
        </Row>
        <small className="m-4">
          {isPopulated &&
            addsForSectionBase &&
            addsForSectionBase.map((add, i) => (
              <Row
                key={i}
                className="mt-2 pt-1 border-top"
              >
                <Col
                  xs={2}
                  className="text-truncate"
                >
                  {add.organisation}
                </Col>
                <Col
                  xs={2}
                  className="text-truncate"
                >
                  {add.title}
                </Col>
                <Col>
                  {add.playDates.map((playDate, j) =>
                    playDate.playTimes.map(
                      (playTime, j) =>
                        playTime.numberOfPlays > 0 && (
                          <Row key={j}>
                            <Col xs={2}>
                              {minutesToHm(playTime.startTime)} to{" "}
                              {minutesToHm(playTime.endTime)}
                            </Col>
                            <Col xs={2}>{playTime.numberOfPlays} - Plays</Col>
                            <Col>
                              {playTime.timeOfPlays &&
                                playTime.timeOfPlays.map(
                                  (timeOfPlay) =>
                                    secondsToHm(timeOfPlay) + ",  "
                                )}
                            </Col>
                          </Row>
                        )
                    )
                  )}
                </Col>
                {/* <Col>{secondsToHms(song.duration)}</Col> */}
              </Row>
            ))}
        </small>
        {/* Promos */}

        <Row className="mt-2 pt-1 border-top">
          <Col
            xs={12}
            className="fs-5"
          >
            Promos
          </Col>
        </Row>

        <small className="m-4">
          {isPopulated &&
            promosForSectionBase &&
            promosForSectionBase.map((promo, i) => (
              <Row
                key={i}
                className="mt-2 pt-1 border-top"
              >
                <Col
                  xs={2}
                  className="text-truncate"
                >
                  {promo.title}
                </Col>
                <Col
                  xs={2}
                  className="text-truncate"
                >
                  {promo.organisation}
                </Col>
                <Col>
                  {promo.playDates.map((playDate, j) =>
                    playDate.playTimes.map(
                      (playTime, j) =>
                        playTime.numberOfPlays > 0 && (
                          <Row key={j}>
                            <Col xs={2}>
                              {minutesToHm(playTime.startTime)} to{" "}
                              {minutesToHm(playTime.endTime)}
                            </Col>
                            <Col xs={2}>{playTime.numberOfPlays} - Plays</Col>
                            <Col>
                              {playTime.timeOfPlays &&
                                playTime.timeOfPlays.map(
                                  (timeOfPlay) =>
                                    secondsToHm(timeOfPlay) + ",  "
                                )}
                            </Col>
                          </Row>
                        )
                    )
                  )}
                </Col>

                {/* <Col>{secondsToHms(song.duration)}</Col> */}
              </Row>
            ))}
        </small>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setShowModalPlaylist(false);
          }}
        >
          Close
        </Button>
        {!isLocked && (
          <>
            <Button
              variant="primary"
              disabled={isPopulated}
              onClick={(e) => {
                setIsPopulated(true);
                handlePopulate(e);
                setIsSaved(false);
              }}
            >
              Populate
            </Button>
            <Button
              variant="primary"
              disabled={!isPopulated}
              onClick={(e) => {
                setIsPopulated(false);
                setAllPrograms(daysPrograms);
              }}
            >
              Clear
            </Button>
            <Button
              variant="primary"
              onClick={handleSaveClick}
              disabled={isSaved}
            >
              Save
            </Button>
          </>
        )}
        <Button
          variant="primary"
          onClick={handlePlaylist}
          disabled={!isSaved}
        >
          Create Playlist File
        </Button>
      </Modal.Footer>
    </>
  );
};
export default ModalPlaylist;
